<template>
<el-dialog :visible="!!editingProject" :title="disalbed? '查看项目': '编辑项目'" width="1000px" @close="closeDialog">
    <el-tabs v-model="currentLang" v-if="!!editingProject">
      <el-tab-pane v-for="item in languageList" :key="item.value" :name="item.value" :label="item.label">
        <el-form :model="detail" :ref="`form-${item.value}`" :rules="rules" label-width="100px">
          <el-form-item label="名称：" :prop="`languageDtos[${item.value}].name`">
            <el-input v-model="detail.languageDtos[item.value].name"></el-input>
          </el-form-item>
          <el-form-item label="币种：" prop="coinType">
            <el-select v-model="detail.coinType" placeholder="请选择">
              <el-option v-for="item in coinTypeList" :key="item" :label="item" :value="item">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="分发币种：" prop="distributionCoinType">
            <el-select v-model="detail.distributionCoinType" placeholder="请选择">
              <el-option v-for="item in coinTypeList" :key="item" :label="item" :value="item">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="token币种：" prop="distributionCoinType">
            <el-input v-model="detail.distributionCoinType"></el-input>
          </el-form-item>
          <el-form-item label="总量：" prop="totalFinancing">
            <el-input-number v-model="detail.totalFinancing" :min="0"></el-input-number>
          </el-form-item>
          <el-form-item label="兑换比例：" prop="proportion">
            <el-input-number v-model="detail.proportion" :min="0"></el-input-number>
          </el-form-item>
          <el-form-item label="最多小数位：" prop="scale">
            <el-input-number v-model="detail.scale" :min="0"></el-input-number>
          </el-form-item>
          <el-form-item label="个人最大额度：" prop="singleLimit">
            <el-input-number v-model="detail.singleLimit" :min="0"></el-input-number>
          </el-form-item>
          <el-form-item label="个人最小额度：" prop="minAmount">
            <el-input-number v-model="detail.minAmount" :min="0"></el-input-number>
          </el-form-item>
          <el-form-item label="是否支持中国大陆：" prop="inland">
            <el-switch
              v-model="detail.inland"
              active-color="#13ce66">
            </el-switch>
          </el-form-item>
          <el-form-item label="是否需要签协议：" prop="sign">
            <el-switch
              v-model="detail.sign"
              active-color="#13ce66">
            </el-switch>
          </el-form-item>
          <el-form-item label="协议链接：" prop="signUrl">
            <el-input v-model="detail.signUrl"></el-input>
          </el-form-item>
          <el-form-item label="起止时间：" required>
            <el-col :span="7">
              <el-form-item prop="startTime" >
                <el-date-picker v-model="detail.startTime" value-format="timestamp" type="datetime" placeholder="选择开始时间">
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="7">
              <el-form-item prop="endTime">
                <el-date-picker v-model="detail.endTime" value-format="timestamp" type="datetime" placeholder="选择截止时间">
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-form-item>
          <el-form-item label="列表页封面图片：" :prop="`imageUrl`">
            <upload v-model="detail.imageUrl" :data="{language: item.value, platform: 1}"></upload>
          </el-form-item>
          <el-form-item label="banner图片：" :prop="`languageDtos[${item.value}].bannerUrl`">
            <upload v-model="detail.languageDtos[item.value].bannerUrl" :data="{language: item.value, platform: 1}"></upload>
          </el-form-item>
          <el-form-item label="详情页头部图片：" :prop="`languageDtos[${item.value}].imageUrl`">
            <upload v-model="detail.languageDtos[item.value].imageUrl" :data="{language: item.value, platform: 1}"></upload>
          </el-form-item>
          <el-form-item label="详情页介绍图片：" :prop="`languageDtos[${item.value}].introduction`">
            <upload v-model="detail.languageDtos[item.value].introduction" :data="{language: item.value, platform: 1}"></upload>
          </el-form-item>
        </el-form>
      </el-tab-pane>
    </el-tabs>
    <span slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">取消</el-button>
      <el-button v-if="!disalbed" type="primary" @click="handleSave()">保存</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex';
import Editor from 'components/editor';
import Upload from 'components/upload';
import LANGUAGE from 'common/languages';
const languageDtos = Object.keys(LANGUAGE).reduce(
  (obj, key) => ({
    ...obj,
    [key]: {}
  }),
  {}
);
export default {
  name: 'foundationProjectDetail',
  data() {
    const validateEndTime = (rule, value, callback) => {
      if (!this.detail.endTime) {
        callback(new Error('请填写'));
      }
      if (
        this.detail.startTime &&
        this.detail.endTime &&
        value < this.detail.startTime
      )
        callback(new Error('截止时间不得早于开始时间'));
      callback();
    };
    const validateStartTime = (rule, value, callback) => {
      if (!this.detail.startTime) {
        callback(new Error('请填写'));
      }
      if (this.detail.startTime < new Date())
        callback(new Error('开始时间不得早于当前时间'));
      callback();
    };
    const languageDtosValidateObj = Object.keys(LANGUAGE).reduce(
      (obj, key) => ({
        ...obj,
        [`languageDtos[${key}].name`]: {
          required: true,
          message: '请填写'
        },
        [`languageDtos[${key}].bannerUrl`]: {
          required: true,
          message: '请填写'
        },
        [`languageDtos[${key}].imageUrl`]: {
          required: true,
          message: '请填写'
        },
        [`languageDtos[${key}].introduction`]: {
          required: true,
          message: '请填写'
        }
      }),
      {}
    );
    return {
      detail: {
        languageDtos: Object.assign({}, languageDtos)
      },
      currentLang: '1',
      rules: {
        ...languageDtosValidateObj,
        name: {
          required: true,
          message: '请填写'
        },
        coinType: {
          required: true,
          message: '请填写'
        },
        totalFinancing: {
          required: true,
          message: '请填写'
        },
        startTime: [
          {
            validator: validateStartTime,
            trigger: 'change'
          }
        ],
        endTime: [
          {
            validator: validateEndTime,
            trigger: 'change'
          }
        ],
        distributionCoinType: {
          required: true,
          message: '请填写'
        },
        proportion: {
          required: true,
          message: '请填写'
        },
        scale: {
          required: true,
          message: '请填写'
        },
        singleLimit: {
          required: true,
          message: '请填写'
        },
        minAmount: {
          required: true,
          message: '请填写'
        },
        imageUrl: {
          required: true,
          message: '请填写'
        }
      }
    };
  },
  computed: {
    ...mapState('foundationProject', [
      'coinTypeList',
      'editingProject',
      'languageList'
    ]),
    submitDetil() {
      return {
        ...this.detail,
        languageDtos: Object.keys(this.detail.languageDtos)
          .map(type => ({
            ...this.detail.languageDtos[type],
            // id: this.detail.languageDtos[type].id && this.detail.languageDtos[type].id.toString(),
            type
          }))
          .filter(
            item => item && item.name && item.imageUrl && item.introduction
          )
      };
    },
    disalbed() {
      return this.detail && this.detail.status !== 0;
    }
  },
  watch: {
    editingProject(val) {
      this.detail =
        val &&
        Object.assign(
          {},
          {
            ...val,
            languageDtos: Object.keys(LANGUAGE).reduce(
              (obj, key) => ({
                ...obj,
                [key]: val.languageDtos.find(item => item.type == key) || {}
              }),
              {}
            )
          }
        );
    }
  },
  components: {
    Editor,
    Upload
  },
  methods: {
    ...mapMutations('foundationProject', ['setEditingProject']),
    ...mapActions('foundationProject', ['update']),
    closeDialog() {
      this.setEditingProject(null);
      this.languageList.forEach(item => {
        this.$refs[`form-${item.value}`][0].resetFields();
      });
    },
    handleSave() {
      let errorsInLang = [];
      const that = this;
      this.languageList.forEach(item => {
        that.$refs[`form-${item.value}`][0].validate(valid => {
          if (!valid) {
            if (!errorsInLang.length) {
              that.currentLang = item.value;
            }
            errorsInLang.push(item.label);
          }
        });
      });
      if (!errorsInLang.length) {
        this.doSave();
      } else if (errorsInLang.length !== this.languageList.length) {
        this.$confirm(
          `[${errorsInLang.join('], [')}]信息中存在未填写的项，确认要提交么？`,
          '提示',
          {
            type: 'warning'
          }
        ).then(() => {
          this.doSave();
        });
      }
    },
    doSave() {
      this.update(this.submitDetil).then(() => {
        this.$message({
          message: '修改成功！',
          type: 'success'
        });
        this.closeDialog();
        this.$emit('refresh', {
          page: 1
        });
      });
    }
  }
};
</script>
